import React, { useEffect } from "react";
import { Sheet as UISheet, SheetProps as UISheetProps } from "@bared/ui";
import { useLiveChat } from "@hooks/useLiveChat";

export interface SheetProps extends UISheetProps {}

export function Sheet(props: SheetProps) {
  const liveChat = useLiveChat();

  useEffect(() => {
    if (props.isOpen) {
      liveChat.hide();
    } else {
      liveChat.show();
    }
  }, [props.isOpen, liveChat]);

  return <UISheet {...props} />;
}
